export default "__VITE_ASSET__zDpRfHjs__"